module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-toolbar clearfix"
  }, [_c('div', {
    staticClass: "toolbar-text"
  }, [(!_vm.quickActionsDocsPath && _vm.markdownDocsPath) ? [_c('a', {
    attrs: {
      "href": _vm.markdownDocsPath,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n        Markdown is supported\n      ")])] : _vm._e(), _vm._v(" "), (_vm.quickActionsDocsPath && _vm.markdownDocsPath) ? [_c('a', {
    attrs: {
      "href": _vm.markdownDocsPath,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n        Markdown\n      ")]), _vm._v("\n      and\n       "), _c('a', {
    attrs: {
      "href": _vm.quickActionsDocsPath,
      "target": "_blank",
      "tabindex": "-1"
    }
  }, [_vm._v("\n        quick actions\n      ")]), _vm._v("\n      are supported\n    ")] : _vm._e()], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "uploading-container"
  }, [_c('span', {
    staticClass: "uploading-progress-container hide"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "attaching-file-message"
  }), _vm._v(" "), _c('span', {
    staticClass: "uploading-progress"
  }, [_vm._v("0%")]), _vm._v(" "), _c('span', {
    staticClass: "uploading-spinner"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "uploading-error-container hide"
  }, [_c('span', {
    staticClass: "uploading-error-icon"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "uploading-error-message"
  }), _vm._v(" "), _c('button', {
    staticClass: "retry-uploading-link",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n          Try again\n      ")]), _vm._v("\n      or\n      "), _c('button', {
    staticClass: "attach-new-file markdown-selector",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n        attach a new file\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "markdown-selector button-attach-file",
    attrs: {
      "tabindex": "-1",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o toolbar-button-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Attach a file\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs hide button-cancel-uploading-files",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n      Cancel\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319f0f0c"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-319f0f0c"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue
// module chunks = common_vue